// esicDisablementTypeSlice.ts

import { createSlice } from "@reduxjs/toolkit";
import {
  EsicDisablementTypeState,
} from "./disablementTypes";
import {
  createEsicDisablementType,
  fetchEsicDisablementTypeList,
  fetchEsicDisablementTypeById,
  updateEsicDisablementType,
  deleteEsicDisablementType,
} from "./disablementAction";

const initialState: EsicDisablementTypeState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

const esicDisablementTypeSlice = createSlice({
  name: "esicDisablementType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Create
    builder.addCase(createEsicDisablementType.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createEsicDisablementType.fulfilled, (state, action) => {
      state.loading = false;
      state.list.push({
        disablement_id: action.payload.id,
        disablement_type: "",
        description: null,
      });
    });
    builder.addCase(createEsicDisablementType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Get All
    builder.addCase(fetchEsicDisablementTypeList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEsicDisablementTypeList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    });
    builder.addCase(fetchEsicDisablementTypeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Get By Id
    builder.addCase(fetchEsicDisablementTypeById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEsicDisablementTypeById.fulfilled, (state, action) => {
      state.loading = false;
      state.selected = action.payload;
    });
    builder.addCase(fetchEsicDisablementTypeById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Update
    builder.addCase(updateEsicDisablementType.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateEsicDisablementType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateEsicDisablementType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Delete
    builder.addCase(deleteEsicDisablementType.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteEsicDisablementType.fulfilled, (state, action) => {
      state.loading = false;
      state.list = state.list.filter(
        (item) => item.disablement_id !== (action.meta.arg as number)
      );
    });
    builder.addCase(deleteEsicDisablementType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default esicDisablementTypeSlice.reducer;
